import React from 'react';
import { Calendar, MapPin, ArrowRight, Flame } from 'lucide-react';
export function Hero() {
  return <section className="relative h-screen flex items-center justify-center overflow-hidden" data-id="element-117">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-118">
        <img src="https://images.unsplash.com/photo-1544025162-d76694265947?w=2070&q=80" alt="Austin Texas BBQ" className="w-full h-full object-cover" data-id="element-119" />
        <div className="absolute inset-0 bg-[#2F1B10] bg-opacity-60 mix-blend-multiply" data-id="element-120"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#2F1B10] via-transparent to-transparent opacity-80" data-id="element-121"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10 text-white text-center md:text-left md:max-w-4xl md:ml-16" data-id="element-122">
        <div className="space-y-6" data-id="element-123">
          <div className="inline-block border-b-2 border-[#D2691E] pb-2" data-id="element-124">
            <h2 className="text-[#F4A460] font-bold text-xl md:text-2xl tracking-widest uppercase font-serif" data-id="element-125">
              Presented by ECOM CFO & ECOM CPA
            </h2>
          </div>

          <h1 className="text-5xl md:text-7xl font-bold leading-tight font-serif" style={{
          fontFamily: 'Rockwell, "Courier New", serif'
        }} data-id="element-126">
            Commerce CFO <br data-id="element-127" />
            <span className="text-[#D2691E]" data-id="element-128">Roundtable - Austin</span>
          </h1>

          <p className="text-xl md:text-3xl font-light max-w-2xl text-[#FFF8DC]" data-id="element-129">
            Two days of insights, tools, and Texas BBQ.
          </p>

          {/* Franklin BBQ Logo & Meet Aaron Franklin */}
          <div className="flex items-center gap-4 py-6 px-6 bg-[#2F1B10] bg-opacity-70 border-l-4 border-[#D2691E] rounded-lg backdrop-blur-sm max-w-xl" data-id="element-130">
            <img src="https://cdn.magicpatterns.com/uploads/sZ8D6ocxjnXfBhmuXSWGSV/Franklin2BBBQ_Logo_4C.png.webp" alt="Franklin Barbecue Logo" className="h-20 w-auto" data-id="element-131" />
            <div className="border-l-2 border-[#D2691E] pl-4" data-id="element-132">
              <p className="text-white text-lg font-semibold" data-id="element-133">
                Meet Aaron Franklin
              </p>
              <p className="text-[#F4A460] text-sm" data-id="element-134">Legendary Pitmaster</p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-6 mt-8 text-lg" data-id="element-135">
            <div className="flex items-center gap-3 bg-[#8B4513] bg-opacity-40 px-4 py-2 rounded-lg border border-[#D2691E] backdrop-blur-sm" data-id="element-136">
              <Calendar className="text-[#F4A460]" size={24} data-id="element-137" />
              <span className="font-medium" data-id="element-138">August 27-28, 2026</span>
            </div>
            <div className="flex items-center gap-3 bg-[#8B4513] bg-opacity-40 px-4 py-2 rounded-lg border border-[#D2691E] backdrop-blur-sm" data-id="element-139">
              <MapPin className="text-[#F4A460]" size={24} data-id="element-140" />
              <span className="font-medium" data-id="element-141">East Austin, TX</span>
            </div>
          </div>

          <div className="pt-10" data-id="element-142">
            <a href="#register" className="inline-flex items-center gap-3 bg-[#D2691E] hover:bg-[#A0522D] text-white font-bold text-lg px-8 py-4 rounded-md transition-all shadow-lg hover:shadow-[#D2691E]/50 transform hover:-translate-y-1" data-id="element-143">
              Reserve Your Seat
              <ArrowRight size={20} data-id="element-144" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}